<template>
	<div class="level">
		<div class="level-left">
			<div class="level-item" v-if="logo"><img src="@/assets/img/android-chrome-48x48.png" alt=""></div>
			<div class="level-item"><h1 class="title">{{ title }}</h1></div>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			title: {
				type: String,
				required: true
			},
			logo: {
				type: Boolean,
				default: true
			}
		},	
		name: 'ModalHeaderTitle',

		data() {
			return {

			};
		},
	};
</script>

<style lang="css" scoped>
.level-item img{
	max-width: 2.5em;
}
</style>
